import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Helper function to trim env vars to remove any trailing whitespace or line endings
const trimEnv = (value: string | undefined): string | undefined => {
  return value?.trim() || undefined;
};

const firebaseConfig = {
  apiKey: trimEnv(process.env.NEXT_PUBLIC_FIREBASE_API_KEY),
  authDomain: trimEnv(process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN),
  projectId: trimEnv(process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID),
  storageBucket: trimEnv(process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET),
  messagingSenderId: trimEnv(process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID),
  appId: trimEnv(process.env.NEXT_PUBLIC_FIREBASE_APP_ID),
  measurementId: trimEnv(process.env.NEXT_PUBLIC_MEASUREMENT_ID),
};

export const vapidKey = trimEnv(process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY);

// Chỉ initialize Firebase nếu có đủ config (tránh lỗi khi build)
let app: ReturnType<typeof initializeApp> | null = null;
let auth: ReturnType<typeof getAuth> | null = null;
let db: ReturnType<typeof getFirestore> | null = null;
let storage: ReturnType<typeof getStorage> | null = null;

// Check if Firebase config is complete
const isFirebaseConfigComplete = () => {
  return (
    firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.storageBucket &&
    firebaseConfig.messagingSenderId &&
    firebaseConfig.appId
  );
};

if (isFirebaseConfigComplete()) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    storage = getStorage(app);
  } catch (error) {
    // Firebase initialization failed
  }
} else {
  // Firebase config is incomplete. Firebase features will be disabled.
}

export { app, auth, db, storage };

type Config = typeof firebaseConfig;

export function getFirebaseConfig(): Config {
  if (!isFirebaseConfigComplete()) {
    throw new Error('Firebase config is not set or incomplete');
  }
  return firebaseConfig;
}
